angular.module('app')
  .factory('authInterceptor', function ($q, $rootScope) {
    return {
      responseError: (response) => {
        if (response.status === 401) {
          $rootScope.$broadcast('AUTH_REQUIRED');
        }

        return $q.reject(response);
      },
    };
  });
